export const isOidcEnabled = () => process.env.VUE_APP_OIDC_ENABLED === 'true'

export const isPwa = () => window.matchMedia('(display-mode: standalone)').matches
